// Zentrale Konfiguration — hier kannst du Kontaktdaten, Links, Bilder und Videos
// später ganz einfach selbst austauschen, ohne im Code suchen zu müssen.

export const CONTACT = {
  email: "Justin.mochkaai@icloud.com",
  phoneDisplay: "+49 157 55501523",
  phoneHref: "+4915755501523",
  // WhatsApp-Nummer ohne +, Leerzeichen und führende 0
  whatsappNumber: "4915755501523",
  whatsappText:
    "Hallo Justin, ich interessiere mich für eine deiner Dienstleistungen.",
};

export const PARTNERS = {
  rent500: {
    url: "https://rent-500.de",
    discountCode: "JUSTIN",
    discountPercent: 10,
    location: "Autovermietung in Unterschleißheim bei München",
    vehicles: [
      {
        name: "Audi R8 Spyder",
        detail: "ohne OPF · 2 Sitze · Automatik",
        specs: "540 PS",
        price: "ab 399 € / Tag",
        image: "/images/rent500/audi-r8-spyder.jpg",
      },
      {
        name: "Toyota Supra GR Legend",
        detail: "2 Sitze · Automatik",
        specs: "340 PS",
        price: "ab 249 € / Tag",
        image: "/images/rent500/toyota-supra-gr.jpg",
      },
      {
        name: "VW Polo GTI Weiß",
        detail: "4 Sitze · Automatik",
        specs: "GTI",
        price: "ab 89 € / Tag",
        image: "/images/rent500/vw-polo-gti-weiss.jpg",
      },
      {
        name: "VW Polo GTI Grau",
        detail: "4 Sitze · Automatik",
        specs: "GTI",
        price: "ab 89 € / Tag",
        image: "/images/rent500/vw-polo-gti-grau.jpg",
      },
      {
        name: "VW Polo GTI Schwarz",
        detail: "5 Sitze · Automatik · Klimaanlage",
        specs: "GTI",
        price: "ab 89 € / Tag",
        image: "/images/rent500/vw-polo-gti-schwarz.jpg",
      },
    ],
  },
  highEnd: {
    url: "https://www.highendent.de",
    // TODO: Beispielbilder/Videos von High End Entertainment eintragen
    image: null,
  },
};

export const IMAGES = {
  about:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1200&auto=format&fit=crop",
  garten:
    "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?q=80&w=1200&auto=format&fit=crop",
  hausmeister:
    "https://images.unsplash.com/photo-1504148455328-c376907d081c?q=80&w=1200&auto=format&fit=crop",
  umzug:
    "https://images.unsplash.com/photo-1600518464441-9154a4dea21b?q=80&w=1200&auto=format&fit=crop",
  entruempelung:
    "https://images.unsplash.com/photo-1586953208448-b95a79798f07?q=80&w=1200&auto=format&fit=crop",
  tierHund:
    "https://images.unsplash.com/photo-1543466835-00a7907e9de1?q=80&w=1200&auto=format&fit=crop",
  tierKatze:
    "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?q=80&w=1200&auto=format&fit=crop",
  designHoodie: "/images/designs/design-1.jpg",
  designShirts: "/images/designs/design-2.jpg",
  designStreetwear: "/images/designs/design-3.jpg",
  designTablet: "/images/designs/design-4.jpg",
  designExtra: "/images/designs/design-5.jpg",
  autoHero:
    "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop",
  autoDetail:
    "https://images.unsplash.com/photo-1493238792000-8113da705763?q=80&w=1200&auto=format&fit=crop",
};

export const HERO_STRIP = [
  { src: IMAGES.garten, alt: "Gartenarbeit" },
  { src: IMAGES.tierHund, alt: "Hundebetreuung" },
  { src: IMAGES.designExtra, alt: "Handgezeichnetes Clothing-Design von Justin" },
  { src: IMAGES.autoHero, alt: "Autosuche" },
];

// Echte Kundenbewertungen hier eintragen, sobald sie vorliegen:
// { name: "Max M.", service: "Gartenservice", text: "...", stars: 5 }
export const REVIEWS = [];

// Festpreis-Pakete (eine Quelle für Landingpage + Buchungsseite)
export const BOOKING_PACKAGES = {
  design: [
    {
      item: "design_standard",
      name: "Standard Design",
      price: 10000,
      points: ["1 individuelles Design, handgezeichnet auf dem Tablet", "Digitale Datei für deinen Produzenten", "1 Korrekturschleife inklusive"],
      quantity: true,
    },
    {
      item: "design_premium",
      name: "Aufwendiges Design",
      price: 13000,
      points: ["Komplexes, detailreiches Design", "Handgezeichnet auf dem Tablet", "Digitale Datei für deinen Produzenten", "1 Korrekturschleife inklusive"],
      quantity: true,
    },
  ],
  brand: [
    {
      item: "brand_starter",
      name: "STARTER",
      price: 19900,
      points: [
        "Gemeinsame Entwicklung der Grundidee deiner Brand",
        "Unterstützung bei der Auswahl von Kleidungsstücken",
        "Hilfe bei Herstellern und Bezugsquellen",
        "Beratung zum ersten Drop",
        "Unterstützung bei Fragen rund um den Start",
        "Erste Ideen für Designs und Produkte",
      ],
      note: "Keine umfangreichen Designarbeiten und keine Website-Erstellung enthalten.",
    },
    {
      item: "brand_complete",
      name: "COMPLETE",
      price: 59900,
      highlight: true,
      points: [
        "Alles aus dem STARTER-Paket",
        "Gemeinsamer Aufbau deiner Clothing Brand",
        "Planung und Vorbereitung des ersten Drops",
        "Bis zu 3 individuelle Designs",
        "Unterstützung bei Produkten und Herstellern",
        "Hilfe bei der Zusammenstellung der ersten Kollektion",
        "Gemeinsamer Aufbau der Website & Online-Auftritt",
        "Begleitung von der Idee bis zum ersten Drop",
      ],
      note: "Einmaliger Preis — keine Abos.",
    },
  ],
  autosuche: [
    {
      item: "auto_basic",
      name: "BASIC",
      price: 4900,
      tagline: "Autos finden",
      points: ["Passende Fahrzeuge im Internet suchen", "Interessante Angebote auswählen", "Angebote an dich weiterleiten", "Bei Bedarf Verkäufer kontaktieren", "Verfügbarkeit des Fahrzeugs abklären"],
    },
    {
      item: "auto_premium",
      name: "PREMIUM",
      price: 9900,
      highlight: true,
      tagline: "Autos finden + Kommunikation & Verhandlung",
      points: ["Alles aus BASIC", "Kommunikation mit Verkäufern", "Weitere Informationen zum Fahrzeug einholen", "Fragen zum Fahrzeug für dich klären", "Unterstützung bei Preisverhandlungen", "Unterstützung bei der weiteren Abwicklung"],
    },
    {
      item: "auto_complete",
      name: "COMPLETE",
      price: 24900,
      tagline: "Rundum-Autosuche",
      points: [
        "Alles aus BASIC + alles aus PREMIUM",
        "Persönliche Fahrzeugbesichtigung im vereinbarten Umkreis",
        "Unterstützung bei der Fahrzeugprüfung",
        "Begleitung bei Besichtigung & Probefahrt",
        "Technische Einschätzung durch eine fachkundige Begleitperson, soweit möglich",
        "Begleitung bei der weiteren Abwicklung",
      ],
      note: "Bei größeren Entfernungen kann ein Fahrtkosten-Aufpreis vereinbart werden. Besichtigung nur nach Absprache, abhängig von Entfernung und Verfügbarkeit.",
    },
  ],
};

export const TIER_PRICING = { hourly_cents: 1500, min_hours: 2, max_hours: 8 };

// ---------- Website-Erstellung (eine Quelle für Landing + Kaufseite) ----------
export const WEBSITE_PACKAGES = [
  {
    id: "plus",
    name: "PLUS",
    price: 69900,
    recommended: true,
    tagline: "Teilautomatisiert — deine Website arbeitet mit",
    automation: { level: "Teilautomatisiert", detail: "mit meinen eigenen Bots & Systemen" },
    desc: "Hier kommen Systeme zum Einsatz, die ich selbst gebaut habe: Kunden füllen Kontaktformulare aus und du bekommst sofort eine Benachrichtigung, Termine laufen über einen Buchungskalender mit echten Verfügbarkeiten, und deine Kunden können direkt online bezahlen. Automatische Bestätigungs-E-Mails und Erinnerungen inklusive — du musst nur noch die Arbeit machen.",
    images: [
      { src: "/images/websites/plus-1.jpg", label: "Moderne animierte Startseite" },
      { src: "/images/websites/plus-2.jpg", label: "Buchungskalender mit Verfügbarkeiten" },
      { src: "/images/websites/plus-3.jpg", label: "Kontaktformular & WhatsApp" },
      { src: "/images/websites/plus-4.jpg", label: "Online-Zahlung" },
      { src: "/images/websites/plus-5.jpg", label: "Bildergalerie" },
    ],
    features: [
      "Individuelle Website mit professionellem Design",
      "Startseite + wichtige Unterseiten & Bildergalerien",
      "Über-mich-/Über-uns-Bereich & Darstellung deiner Leistungen",
      "Deine Bilder und Texte, Telefon, E-Mail & WhatsApp-Button",
      "Optimiert für Smartphone, Tablet & PC",
      "Domain-Anbindung & Veröffentlichung",
      "Moderne Animationen & Übergänge",
      "Kontaktformulare mit E-Mail-Integration",
      "Termin- & Buchungskalender mit Verfügbarkeiten",
      "Zahlungsfunktion (verschiedene Zahlungsarten)",
      "Automatische E-Mail-Bestätigungen & Benachrichtigungen",
      "Einfache Verwaltung deiner Kundenanfragen",
      "Social-Media-Verknüpfungen & Google Maps",
      "Erweitertes SEO (damit man dich findet)",
    ],
  },
  {
    id: "premium",
    name: "PREMIUM",
    price: 129900,
    tagline: "Vollautomatisiert — dein digitales Geschäftssystem",
    automation: { level: "Vollautomatisiert", detail: "KI, Bots & eigener Adminbereich" },
    desc: "Das volle Programm — exakt das System, mit dem auch diese Website hier läuft: Dein eigener Admin-Login mit Dashboard, automatische Rechnungen und Verträge zum digitalen Unterschreiben, Erinnerungen und Mahnungen von allein, eine KI, die neue Anfragen für dich voranalysiert und Preise vorschlägt, Besucher-Statistiken, Rabattcodes und Push-Benachrichtigungen auf dein Handy. Dein Geschäft läuft im Hintergrund von allein — du schaust nur noch ins Dashboard.",
    images: [
      { src: "/images/websites/premium-1.jpg", label: "Dein persönliches Dashboard" },
      { src: "/images/websites/premium-2.jpg", label: "Rechnungen: offen & bezahlt" },
      { src: "/images/websites/premium-3.jpg", label: "Buchungs- & Kalenderverwaltung" },
      { src: "/images/websites/premium-4.jpg", label: "Statistiken & Analysen" },
      { src: "/images/websites/premium-5.jpg", label: "Kundenverwaltung" },
    ],
    features: [
      "Alles aus PLUS",
      "Komplett individuelles Webdesign",
      "Eigener Kunden-/Adminbereich mit Login",
      "Kundenverwaltung & Dienstleistungsverwaltung",
      "Automatisierte Rechnungen & E-Mails",
      "Automatische Buchungsbestätigungen & Erinnerungen",
      "Übersicht über offene & bezahlte Rechnungen",
      "Automatische Preis- & Stundenberechnung",
      "Analysen, Statistiken & Besucher-Auswertung",
      "Automatisierte Workflows & Systemüberwachung",
      "Verträge & Dokumente im Adminbereich",
      "KI-Funktionen, wenn sie für dich sinnvoll sind",
    ],
  },
];

export const WEBSITE_EXPRESS = {
  price: 10000,
  label: "Express-Lieferung",
  tagline: "Deine Website ist innerhalb von 48 Stunden fertig.",
  note: "Ab Zahlungseingang. Damit ich sofort loslegen kann, schickst du mir direkt danach deine Inhalte (Texte, Bilder, Logo).",
};


export const WEBSITE_BETRIEB = {
  price: 1000,
  label: "Website-Betrieb",
  note: "Damit deine Website online bleibt und die technischen Funktionen betrieben werden können. Diese Gebühr deckt ausschließlich die laufenden Betriebskosten — sie ist keine Gewinnmarge. Startet erst am Tag, an dem deine Website fertig wird.",
};

export const WEBSITE_SUPPORT = [
  {
    id: "basic",
    name: "SUPPORT BASIC",
    price: 3900,
    tagline: "Ich halte deine Website technisch am Laufen",
    points: [
      "Überwachung deiner Website",
      "Fehlerbehebung bei technischen Problemen",
      "Prüfung, ob wichtige Funktionen laufen",
      "Deine Website bleibt ordnungsgemäß online",
    ],
    note: "Ohne inhaltliche Änderungen — neue Bilder, Texte oder Funktionen sind separate Leistungen.",
  },
  {
    id: "premium",
    name: "SUPPORT PREMIUM",
    price: 5900,
    tagline: "Technik + 2 Änderungen pro Monat",
    recommended: true,
    points: [
      "Alles aus SUPPORT BASIC",
      "2 individuelle Änderungen pro Monat",
      "z. B. neues Bild, Text ändern, Dienstleistung ergänzen",
      "z. B. Farbe eines Bereichs oder Button ändern",
    ],
    note: "Nicht genutzte Änderungen verfallen am Monatsende (keine Übertragung).",
  },
];

